<template>
    <tr>
        <td v-if="!isEditionFormDisplayed">{{ hotlineContact.name }}</td>
        <td v-if="!isEditionFormDisplayed">{{ hotlineContact.phone }}</td>
        <td v-if="!isEditionFormDisplayed">{{ hotlineContact.email }}</td>
        <td align="middle" v-if="!isEditionFormDisplayed && !contract.terminated">
            <button class="btn btn-sm"
                    :class="{disabled: actionsDisabled}"
                    @click="displayEditionForm">Modifier</button>
            <button class="btn btn-sm"
                    :class="{disabled: actionsDisabled}"
                    @click="removeHotlineContact(hotlineContact)">Supprimer</button>
        </td>
        <td colspan="4" v-if="isEditionFormDisplayed" style="background-color: #fafafa;">
            <resource-form :schema="editionForm.schema"
                        :model="editionForm.model"
                        :triggers="editionForm.triggers"
                        @submit="handleHotlineContactEdition">
                <button slot="cancel"
                        class="btn btn-danger btn-sm"
                        @click.prevent="hideEditionForm">
                    Annuler
                </button>
            </resource-form>
        </td>
    </tr>
</template>

<script type="text/babel">
    import { mapActions } from 'vuex'
    import ResourceForm from "components/Forms/ResourceForm"

    export default {
        name:"HotlineContactItem",

        components: {
            ResourceForm
        },

        props: {
            contractId: {
                required: true
            },
            contractOptionId: {
                required: true
            },
            hotlineContact: {
                required: true
            },
            actionsDisabled: {
                type: Boolean,
                required: true,
                default: false
            },
            contract : {
                type: Object
            }
        },

        data () {
            return {
                isEditionFormDisplayed: false,
                editionForm: {
                    schema: {},
                    model: {},
                    triggers: {},
                }
            }
        },

        methods: {
            ...mapActions('contract', [
                'updateHotlineContact',
                'removeHotlineContact'
            ]),

            displayEditionForm() {
                this.axios.get(`contracts/${this.contractId}/options/${this.contractOptionId}/hotline_contacts/${this.hotlineContact.id}/edit`)
                    .then(response => {
                        let { form } = response.data
                        this.editionForm = _.assign({}, form)
                        this.isEditionFormDisplayed = true
                        this.$emit('edition-form-status-updated', true)
                    })
            },

            hideEditionForm() {
                this.$emit('edition-form-status-updated', false)

                this.isEditionFormDisplayed = false
            },

            handleHotlineContactEdition({ data: model }) {
                console.log(model)

                this.updateHotlineContact(model)
                    .then(() => this.hideEditionForm())
            }
        },
    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/HotlineContacts/HotlineContactItem.vue